<template>
  <v-col>
    <v-row class="ma-0">
      <v-col class="col-auto py-0">
        <span
          v-if="showDashboard"
          class="subtitle-2 nearblack--text"
        >{{ dashboardTitle }}</span>

        <span
          v-else
          class="subtitle-2 primary--text cursor-pointer"
          @click="goToDashboard"
        >{{ dashboardTitle }}</span>
      </v-col>

      <v-col
        v-if="!showDashboard"
        class="col-auto py-0 px-0"
      >
        <font-awesome-icon
          :icon="['fas', 'chevron-right']"
          class="gray--text"
          style="font-size: 9px; margin-bottom: 1px;"
        />
      </v-col>

      <v-col
        v-if="!showDashboard"
        class="col-auto py-0"
      >
        <span class="subtitle-2">{{ objectTitle }}</span>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import { titlecase } from 'src/utils/format'

const { mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'BreadCrumbs',
  data() {
    return {
      actions: [
        {
          event: 'delivery/openTabToLineItem',
          name: 'Go to Line Item',
        },
        {
          event: 'delivery/openTabToOrder',
          name: 'Go to Order',
        },
        {
          event: 'delivery/showCreativesDiscrepancyModal',
          name: 'Creatives Discrepancy',
        },
      ],
    }
  },
  computed: {
    ...mapToolsState({
      selectedSearch: (state) => state.selectedSearch,
    }),
    showDashboard() {
      return this.selectedSearch?.dataType === 'custom'
    },
    dashboardTitle() {
      return titlecase(this.selectedSearch?.reportKey.replace(/-/g, ' ') || '')
    },
    objectTitle() {
      return this.selectedSearch?.text || ''
    },
  },
  methods: {
    goToDashboard() {
      const { name: routeName, params } = this.$route
      const { reportName } = params
      const isReportDashboard = ['admin', 'internal', 'reports', 'settings'].includes(routeName)
      const dashboardMap = {
        dashboard: '/',
      }

      const path = dashboardMap[reportName] || (isReportDashboard ? `/${routeName}/${reportName}` : `/${routeName}`)

      this.$router.push({ path })
    },
  },
}
</script>
